import { useQuery } from '/src/api';
import { formatCurrency } from '/src/utils';
import graphQLQueries from './graph-ql-queries';

import en_GB from './locales/en_GB.json';

const LOCALES = {
    en_GB: en_GB,
};

const useStoreConfig = () => {
    const {
        data: storeConfig,
        isLoading: isLoadingStoreConfig,
        errors: storeConfigErrors,
        runQuery: getStoreConfig
    } = useQuery({
        query: graphQLQueries.storeConfig,
        queryKey: ['storeConfig'],
    });

    const translate = (text, ...params) => {
        let result = LOCALES[storeConfig?.locale]
            ? LOCALES[storeConfig?.locale][text] || text
            : text;

        params.forEach((param, index) => {
            result = result.replace(`%${index + 1}`, param);
        });

        return result;
    };

    const formatDate = date => {
        const { locale } = storeConfig;
        const formatter = new Intl.DateTimeFormat(locale.replace('_', '-'));

        return formatter.format(new Date(date.replace(/-/g, '/')));
    };

    const formatPrice = ({ value, currency })  => {
        const { locale } = storeConfig;
        const formatter = new Intl.NumberFormat(locale.replace('_', '-'), {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });

        if (currency === 'RON') {
            return `${formatter.format(value)}${formatCurrency(currency)}`;
        }

        return `${formatCurrency(currency)}${formatter.format(value)}`;
    };

    return {
        storeConfig,
        isLoadingStoreConfig,
        storeConfigErrors,
        getStoreConfig,
        translate,
        formatDate,
        formatPrice,
    };
};

export default useStoreConfig;
